/* tslint:disable */

declare var Object: any;
export interface ViewLeaveBalanceReportInterface {
  "empId"?: string;
  "fullName"?: string;
  "posNameEn"?: string;
  "leavetype"?: string;
  "startvaliddate": Date;
  "endvaliddate"?: Date;
  "entitlement"?: string;
  "bringforward"?: string;
  "used"?: string;
  "remaining"?: string;
  "activeStatus": number;
  "leaveCode": string;
}

export class ViewLeaveBalanceReport implements ViewLeaveBalanceReportInterface {
  "empId": string;
  "fullName": string;
  "posNameEn": string;
  "leavetype": string;
  "startvaliddate": Date;
  "endvaliddate": Date;
  "entitlement": string;
  "bringforward": string;
  "used": string;
  "remaining": string;
  "activeStatus": number;
  "leaveCode": string;
  constructor(data?: ViewLeaveBalanceReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ViewLeaveBalanceReport`.
   */
  public static getModelName() {
    return "ViewLeaveBalanceReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ViewLeaveBalanceReport for dynamic purposes.
  **/
  public static factory(data: ViewLeaveBalanceReportInterface): ViewLeaveBalanceReport{
    return new ViewLeaveBalanceReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ViewLeaveBalanceReport',
      plural: 'ViewLeaveBalanceReports',
      path: 'ViewLeaveBalanceReports',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "posNameEn": {
          name: 'posNameEn',
          type: 'string'
        },
        "leavetype": {
          name: 'leavetype',
          type: 'string'
        },
        "startvaliddate": {
          name: 'startvaliddate',
          type: 'Date'
        },
        "endvaliddate": {
          name: 'endvaliddate',
          type: 'Date'
        },
        "entitlement": {
          name: 'entitlement',
          type: 'string'
        },
        "bringforward": {
          name: 'bringforward',
          type: 'string'
        },
        "used": {
          name: 'used',
          type: 'string'
        },
        "remaining": {
          name: 'remaining',
          type: 'string'
        },
        "activeStatus": {
          name: 'activeStatus',
          type: 'number'
        },
        "leaveCode": {
          name: 'leaveCode',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/ViewLeaveBalanceReport.ts